var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "allOffersPage" } },
    [
      _c("Titlebar", { attrs: { backPath: "/home" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("nav.offers")))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row " }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("UiCard", { staticClass: "card-item" }, [
              _c("div", { staticClass: "card-item-top" }, [
                _c("span", {
                  staticClass: "pictoBtn",
                  domProps: { innerHTML: _vm._s(_vm.pictoStandard) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "title-wrapper" }, [
                  _c("h2", { staticClass: "title-min" }, [
                    _vm._v(_vm._s(_vm.$t("offers.offer"))),
                  ]),
                  _vm._v(" "),
                  _c("h2", { staticClass: "colored-title" }, [
                    _vm._v("Standard"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-item-section" }, [
                _c("div", { staticClass: "card-item-section__heading" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/img/offers/iPhoneXR_2@2x.png"),
                      alt: "application beepiz",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v(_vm._s(_vm.$t("offers.subtitle1")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "colored-sentence" }, [
                      _vm._v(_vm._s(_vm.$t("offers.app"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-item-section__content" }, [
                  _c("p", { staticClass: "section-content__title" }, [
                    _vm._v(_vm._s(_vm.$t("offers.standard.p1"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-item-section__content-list" },
                    [
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.standard.p2")))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.standard.p3")))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("offers.standard.p4")) + " "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("offers.standard.s4"))),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-item-section" }, [
                _c("div", { staticClass: "card-item-section__heading" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/img/offers/Mockup navigateur Beepiz.png"),
                      alt: "navigateur beepiz",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v(_vm._s(_vm.$t("offers.subtitle2")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "colored-sentence" }, [
                      _vm._v(_vm._s(_vm.$t("offers.web"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-item-section__content" }, [
                  _c("p", { staticClass: "section-content__title" }, [
                    _vm._v(_vm._s(_vm.$t("offers.standard.p5"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-item-section__content-list" },
                    [
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.standard.p6")))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.standard.p7")))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.standard.p8")))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.standard.p9")))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("offers.standard.p10")) + " "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("offers.standard.s10"))),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-item__price" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("offers.from")) + " "),
                  _c("span", [_vm._v("5,99€")]),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://share.hsforms.com/1T6dV1wNfRJ2B_oHU9jKMFw56ack",
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("offers.interested")))]
                ),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("UiCard", { staticClass: "card-item" }, [
              _c("div", { staticClass: "card-item-top" }, [
                _c("span", {
                  staticClass: "pictoBtn",
                  domProps: { innerHTML: _vm._s(_vm.pictoPremium) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "title-wrapper" }, [
                  _c("h2", { staticClass: "title-min" }, [
                    _vm._v(_vm._s(_vm.$t("offers.offer"))),
                  ]),
                  _vm._v(" "),
                  _c("h2", { staticClass: "colored-title" }, [
                    _vm._v("Premium"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "offer-row offer-row" }, [
                _c("span", {
                  staticClass: "pictoBtnRow",
                  domProps: { innerHTML: _vm._s(_vm.pictoStandard) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "offer-row-content" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("offers.fonctionnality")))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "offer-row-content__colored" }, [
                    _vm._v(_vm._s(_vm.$t("offers.standard.title"))),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "plus-row" }, [
                _vm._v("\n          +\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-item-section" }, [
                _c("div", { staticClass: "card-item-section__heading" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/img/offers/iPhoneXR_2@2x.png"),
                      alt: "application beepiz",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v(_vm._s(_vm.$t("offers.subtitle1")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "colored-sentence" }, [
                      _vm._v(_vm._s(_vm.$t("offers.app"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-item-section__content" }, [
                  _c("p", { staticClass: "section-content__title" }, [
                    _vm._v(_vm._s(_vm.$t("offers.premium.p1"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-item-section__content-list" },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("offers.premium.p2")) +
                            "\n                "
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("offers.premium.s2"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.premium.p3")))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("offers.premium.p4")) +
                            "\n                "
                        ),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("offers.premium.s4"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.premium.p5")))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.premium.p6")))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.premium.p11")))]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-item-section" }, [
                _c("div", { staticClass: "card-item-section__heading" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/img/offers/Mockup navigateur Beepiz.png"),
                      alt: "navigateur beepiz",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v(_vm._s(_vm.$t("offers.subtitle2")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "colored-sentence" }, [
                      _vm._v(_vm._s(_vm.$t("offers.web"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-item-section__content" }, [
                  _c("p", { staticClass: "section-content__title" }, [
                    _vm._v(_vm._s(_vm.$t("offers.premium.p7"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-item-section__content-list" },
                    [
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.premium.p8")))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.premium.p9")))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.premium.p10")))]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-item__price" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("offers.from")) + " "),
                  _c("span", [_vm._v("8,99€")]),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://share.hsforms.com/1Hd-hL75OSbG-mg4nfQF_hg56ack",
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("offers.interested")))]
                ),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("UiCard", { staticClass: "card-item" }, [
              _c("div", { staticClass: "card-item-top" }, [
                _c("span", {
                  staticClass: "pictoBtn",
                  domProps: { innerHTML: _vm._s(_vm.pictoEnterprise) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "title-wrapper" }, [
                  _c("h2", { staticClass: "title-min" }, [
                    _vm._v(_vm._s(_vm.$t("offers.offer"))),
                  ]),
                  _vm._v(" "),
                  _c("h2", { staticClass: "colored-title" }, [
                    _vm._v("Enterprise"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "offer-row offer-row-first" }, [
                _c("span", {
                  staticClass: "pictoBtnRow",
                  domProps: { innerHTML: _vm._s(_vm.pictoStandard) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "offer-row-content" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("offers.fonctionnality")))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "offer-row-content__colored" }, [
                    _vm._v(_vm._s(_vm.$t("offers.standard.title"))),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "offer-row" }, [
                _c("span", {
                  staticClass: "pictoBtnRow",
                  domProps: { innerHTML: _vm._s(_vm.pictoPremium) },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "offer-row-content" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("offers.fonctionnality")))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "offer-row-content__colored" }, [
                    _vm._v(_vm._s(_vm.$t("offers.premium.title"))),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "plus-row" }, [
                _vm._v("\n          +\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-item-section" }, [
                _c("div", { staticClass: "card-item-section__heading" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/img/offers/Mockup navigateur Beepiz.png"),
                      alt: "navigateur beepiz",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v(_vm._s(_vm.$t("offers.subtitle2")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "colored-sentence" }, [
                      _vm._v(_vm._s(_vm.$t("offers.web"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-item-section__content" }, [
                  _c("p", { staticClass: "section-content__title" }, [
                    _vm._v(_vm._s(_vm.$t("offers.enterprise.p1"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-item-section__content-list" },
                    [
                      _c("p", [_vm._v(_vm._s(_vm.$t("offers.enterprise.p2")))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("offers.enterprise.soon"))),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-item__price" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("offers.from")) + " "),
                  _c("span", [_vm._v("13,99€")]),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://share.hsforms.com/1IMcu3u-8Sm6CZtdv9EKpMA56ack",
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("offers.interested")))]
                ),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col col mt-5" },
          [
            _c(
              "UiCard",
              { staticClass: "card-item prospection card-item__price" },
              [
                _c("h4", [_vm._v(_vm._s(_vm.$t("offers.prospect.p1")))]),
                _vm._v(" "),
                _c("h4", [_vm._v(_vm._s(_vm.$t("offers.prospect.p2")))]),
                _vm._v(" "),
                _c("h4", [_vm._v(_vm._s(_vm.$t("offers.prospect.p3")))]),
                _vm._v(" "),
                _c("h5", [_vm._v(_vm._s(_vm.$t("offers.prospect.p4")))]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://share.hsforms.com/1_3U7ksu8TKSdh36zAzRo2A56ack",
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("offers.prospect.p5")))]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }